import { render, staticRenderFns } from "./UserEmailPopupView.vue?vue&type=template&id=b80cbbc0&"
import script from "./UserEmailPopupView.vue?vue&type=script&lang=js&"
export * from "./UserEmailPopupView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports